export default __webpack_public_path__ + "static/Jabrille_Lotus_Trading-16a69845c7ee63d45a09c345beb08cbb.mp4";